// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Char from "../Data.Char/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as StringParser_CodePoints from "../StringParser.CodePoints/index.js";
import * as StringParser_Combinators from "../StringParser.Combinators/index.js";
import * as StringParser_Parser from "../StringParser.Parser/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var fromJust = /* #__PURE__ */ Data_Maybe.fromJust();
var map = /* #__PURE__ */ Data_Functor.map(StringParser_Parser.functorParser);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorNonEmptyList);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(StringParser_Parser.bindParser);
var $$void = /* #__PURE__ */ Data_Functor["void"](StringParser_Parser.functorParser);
var pure = /* #__PURE__ */ Control_Applicative.pure(StringParser_Parser.applicativeParser);
var alt = /* #__PURE__ */ Control_Alt.alt(StringParser_Parser.altParser);
var domainPartIsSymbol = {
    reflectSymbol: function () {
        return "domainPart";
    }
};
var localPartIsSymbol = {
    reflectSymbol: function () {
        return "localPart";
    }
};
var applySecond = /* #__PURE__ */ Control_Apply.applySecond(StringParser_Parser.applyParser);
var bind = /* #__PURE__ */ Control_Bind.bind(StringParser_Parser.bindParser);
var fold1 = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList)(Data_Monoid.monoidString);
var EmailAddress = function (x) {
    return x;
};
var unsafeFromCharCode = function ($61) {
    return fromJust(Data_Char.fromCharCode($61));
};
var takeWhile1 = function (f) {
    return map((function () {
        var $62 = map1(Data_String_CodeUnits.singleton);
        return function ($63) {
            return fold($62($63));
        };
    })())(StringParser_Combinators.many1(StringParser_CodePoints.satisfy(f)));
};
var skipMany1 = function (p) {
    return discard($$void(p))(function () {
        return discard($$void(skipMany(p)))(function () {
            return pure(Data_Unit.unit);
        });
    });
};
var skipMany = function (p) {
    return alt(skipMany1(p))(pure(Data_Unit.unit));
};
var skipWhile1 = function (x) {
    return discard($$void(StringParser_CodePoints.satisfy(x)))(function () {
        return discard($$void(skipMany(StringParser_CodePoints.satisfy(x))))(function () {
            return pure(Data_Unit.unit);
        });
    });
};
var nullChar = /* #__PURE__ */ StringParser_CodePoints["char"](/* #__PURE__ */ unsafeFromCharCode(0));
var localPart = function (v) {
    return v.localPart;
};
var lf = /* #__PURE__ */ StringParser_CodePoints["char"]("\x0a");
var isWsp = function (x) {
    return x === " " || x === "\x09";
};
var whiteSpace = /* #__PURE__ */ StringParser_CodePoints.satisfy(isWsp);
var whiteSpace1 = /* #__PURE__ */ skipWhile1(isWsp);
var isAlphaNum = function (x) {
    var isDigit = x >= "0" && x <= "9";
    var isAlpha_ascii = x >= "a" && x <= "z" || x >= "A" && x <= "Z";
    return isDigit || isAlpha_ascii;
};
var inClassRange = function (start) {
    return function (end) {
        return function (c) {
            return c >= start && c <= end;
        };
    };
};
var isVchar = /* #__PURE__ */ inClassRange(/* #__PURE__ */ unsafeFromCharCode(33))(/* #__PURE__ */ unsafeFromCharCode(126));
var vchar = /* #__PURE__ */ StringParser_CodePoints.satisfy(isVchar);
var inClass = function (string) {
    return function ($$char) {
        return Data_String_CodeUnits.contains(Data_String_CodeUnits.singleton($$char))(string);
    };
};
var isObsNoWsCtl = function (c) {
    return inClassRange(unsafeFromCharCode(1))(unsafeFromCharCode(8))(c) || (inClassRange(unsafeFromCharCode(14))(unsafeFromCharCode(31))(c) || inClass("\x0b\x0c\x7f")(c));
};
var isCommentText = function (x) {
    return inClassRange(unsafeFromCharCode(33))(unsafeFromCharCode(39))(x) || (inClassRange(unsafeFromCharCode(42))(unsafeFromCharCode(91))(x) || (inClassRange(unsafeFromCharCode(93))(unsafeFromCharCode(126))(x) || isObsNoWsCtl(x)));
};
var isDomainText = function (x) {
    return inClassRange(unsafeFromCharCode(33))(unsafeFromCharCode(90))(x) || (inClassRange(unsafeFromCharCode(94))(unsafeFromCharCode(126))(x) || isObsNoWsCtl(x));
};
var obsNoWsCtl = /* #__PURE__ */ StringParser_CodePoints.satisfy(isObsNoWsCtl);
var isQuotedText = function (x) {
    return inClass(Data_String_CodeUnits.singleton(unsafeFromCharCode(33)))(x) || (inClassRange(unsafeFromCharCode(35))(unsafeFromCharCode(91))(x) || (inClassRange(unsafeFromCharCode(93))(unsafeFromCharCode(126))(x) || isObsNoWsCtl(x)));
};
var genericEmailAddress = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showEmailAddress = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericEmailAddress)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(domainPartIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(localPartIsSymbol)(Data_Show.showString))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "EmailAddress";
        }
    }))
};
var eqEmailAddress = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericEmailAddress)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(localPartIsSymbol)(Data_Eq.eqString))()(domainPartIsSymbol)(Data_Eq.eqString)))))
};
var domainPart = function (v) {
    return v.domainPart;
};
var toString = function (email) {
    return localPart(email) + ("@" + domainPart(email));
};
var cr = /* #__PURE__ */ StringParser_CodePoints["char"]("\x0d");
var crlf = /* #__PURE__ */ $$void(/* #__PURE__ */ applySecond(cr)(lf));
var whiteSpaceOrNewLine = /* #__PURE__ */ (function () {
    var p2 = skipMany1(applySecond(crlf)(whiteSpace1));
    var p1 = applySecond(whiteSpace1)(StringParser_Combinators.optional(applySecond(crlf)(whiteSpace1)));
    return alt(p1)(p2);
})();
var quotedPair = /* #__PURE__ */ (function () {
    var what = discard($$void(StringParser_CodePoints["char"]("\\")))(function () {
        return alt(vchar)(alt(whiteSpace)(alt(lf)(alt(cr)(alt(obsNoWsCtl)(nullChar)))));
    });
    return bind(what)(function (c) {
        return pure("\\" + Data_String_CodeUnits.singleton(c));
    });
})();
var quotedContent = /* #__PURE__ */ alt(/* #__PURE__ */ takeWhile1(isQuotedText))(quotedPair);
var quotedString = /* #__PURE__ */ (function () {
    var what = discard($$void(StringParser_CodePoints["char"]("\"")))(function () {
        return bind(StringParser_Combinators.many(applySecond(StringParser_Combinators.optional(whiteSpaceOrNewLine))(quotedContent)))(function (ret) {
            return discard($$void(StringParser_Combinators.optional(whiteSpaceOrNewLine)))(function () {
                return discard($$void(StringParser_CodePoints["char"]("\"")))(function () {
                    return pure(ret);
                });
            });
        });
    });
    return map(function (x) {
        return "\"" + (fold1(x) + "\"");
    })(what);
})();
var $lazy_comment = /* #__PURE__ */ $runtime_lazy("comment", "Text.Email.Parser", function () {
    return discard($$void(StringParser_CodePoints["char"]("(")))(function () {
        return discard(skipMany(alt(skipWhile1(isCommentText))(alt($$void(quotedPair))(alt($lazy_comment(155))(whiteSpaceOrNewLine)))))(function () {
            return discard($$void(StringParser_CodePoints["char"](")")))(function () {
                return pure(Data_Unit.unit);
            });
        });
    });
});
var comment = /* #__PURE__ */ $lazy_comment(152);
var commentOrWhiteSpace = /* #__PURE__ */ skipMany(/* #__PURE__ */ alt(comment)(whiteSpaceOrNewLine));
var domainLiteral = /* #__PURE__ */ discard(/* #__PURE__ */ StringParser_Combinators.optional(commentOrWhiteSpace))(function () {
    return discard($$void(StringParser_CodePoints["char"]("[")))(function () {
        return bind(StringParser_Combinators.many(applySecond(StringParser_Combinators.optional(whiteSpaceOrNewLine))(takeWhile1(isDomainText))))(function (domainText) {
            return discard(StringParser_Combinators.optional(whiteSpaceOrNewLine))(function () {
                return discard($$void(StringParser_CodePoints["char"]("]")))(function () {
                    return discard(StringParser_Combinators.optional(commentOrWhiteSpace))(function () {
                        return pure("[" + (fold1(domainText) + "]"));
                    });
                });
            });
        });
    });
});
var atom = /* #__PURE__ */ (function () {
    var isAtomText = function (x) {
        return isAlphaNum(x) || inClass("!#$%&'*+/=?^_`{|}~-")(x);
    };
    return takeWhile1(isAtomText);
})();
var dottedAtoms = /* #__PURE__ */ (function () {
    var inner2 = discard($$void(StringParser_Combinators.optional(commentOrWhiteSpace)))(function () {
        return bind(alt(atom)(quotedString))(function (ret) {
            return discard($$void(StringParser_Combinators.optional(commentOrWhiteSpace)))(function () {
                return pure(ret);
            });
        });
    });
    var inner1 = StringParser_Combinators.sepBy1(inner2)(StringParser_CodePoints["char"]("."));
    return map(Data_Foldable.intercalate(Data_List_Types.foldableNonEmptyList)(Data_Monoid.monoidString)("."))(inner1);
})();
var domain = /* #__PURE__ */ alt(dottedAtoms)(domainLiteral);
var local = dottedAtoms;
var addrSpec = /* #__PURE__ */ bind(local)(function (l) {
    return bind(StringParser_CodePoints["char"]("@"))(function () {
        return bind(domain)(function (d) {
            return bind(StringParser_CodePoints.eof)(function () {
                return pure({
                    localPart: l,
                    domainPart: d
                });
            });
        });
    });
});
export {
    EmailAddress,
    addrSpec,
    domainPart,
    localPart,
    toString,
    genericEmailAddress,
    showEmailAddress,
    eqEmailAddress
};
//# sourceMappingURL=index.js.map
